import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadDocumentFrontMobileView = _resolveComponent("UploadDocumentFrontMobileView")!
  const _component_UploadDocumentFrontDesktopView = _resolveComponent("UploadDocumentFrontDesktopView")!

  return (_ctx.isMobile && !_ctx.noPermissions)
    ? (_openBlock(), _createBlock(_component_UploadDocumentFrontMobileView, {
        key: 0,
        "translation-key": _ctx.TRANSLATION_KEY,
        "is-show-welcome-message": _ctx.isShowWelcomeMessage,
        "no-permissions": _ctx.noPermissions,
        loading: _ctx.loading,
        "is-bad-upload": _ctx.isBadUpload,
        "is-back": _ctx.isBack,
        "is-mobile": _ctx.isMobileLayout,
        "is-photo-upload": _ctx.isPhotoUpload,
        "show-instructions": _ctx.showInstructions,
        "show-popup": _ctx.showPopup,
        "show-help": _ctx.showHelp,
        "show-how-to-take-picture": _ctx.showHowToTakePicture,
        "is-securing-connection": _ctx.isSecuringConnection,
        "is-show-camera": _ctx.isShowCamera,
        "help-available": _ctx.helpAvailable,
        "show-custom-notification": _ctx.showCustomNotification,
        "security-popup": _ctx.securityPopup,
        "show-loader": _ctx.showLoader,
        "handle-init-camera": _ctx.handleInitCamera,
        "handle-show-popup": _ctx.handleShowPopup,
        "handle-how-to-take-picture": _ctx.handleHowToTakePicture,
        "show-camera-selection": _ctx.showCameraSelection,
        "handle-manual": _ctx.handleManual,
        "handle-security": _ctx.handleSecurity,
        "handle-upload": _ctx.handleUpload,
        "handle-back-to-mobile-upload": _ctx.handleBackToMobileUpload,
        "handle-upload-later": _ctx.handleUploadLater
      }, null, 8, ["translation-key", "is-show-welcome-message", "no-permissions", "loading", "is-bad-upload", "is-back", "is-mobile", "is-photo-upload", "show-instructions", "show-popup", "show-help", "show-how-to-take-picture", "is-securing-connection", "is-show-camera", "help-available", "show-custom-notification", "security-popup", "show-loader", "handle-init-camera", "handle-show-popup", "handle-how-to-take-picture", "show-camera-selection", "handle-manual", "handle-security", "handle-upload", "handle-back-to-mobile-upload", "handle-upload-later"]))
    : (_openBlock(), _createBlock(_component_UploadDocumentFrontDesktopView, {
        key: 1,
        "translation-key": _ctx.TRANSLATION_KEY,
        "is-bad-upload": _ctx.isBadUpload,
        "is-back": _ctx.isBack,
        "is-mobile": _ctx.isMobileLayout,
        "is-photo-upload": _ctx.isPhotoUpload,
        "show-help": _ctx.showHelp,
        "show-popup": _ctx.showPopup,
        "is-show-camera": _ctx.isShowCamera,
        "show-loader": _ctx.showLoader,
        "handle-show-popup": _ctx.handleShowPopup,
        "handle-back-to-mobile-upload": _ctx.handleBackToMobileUpload,
        "handle-upload-later": _ctx.handleUploadLater
      }, null, 8, ["translation-key", "is-bad-upload", "is-back", "is-mobile", "is-photo-upload", "show-help", "show-popup", "is-show-camera", "show-loader", "handle-show-popup", "handle-back-to-mobile-upload", "handle-upload-later"]))
}